// Page

// Fix animated icons
$(".fa-spin").empty();

var $sectionColor = $(".section__color");
var $note = $('[data-note="colored"]');
var $callout = $('[data-callout="colored"]');

$sectionColor.each(function() {
  var $this = $(this);

  $this.click(function() {
    var calloutColor = $this.attr("data-color");

    $note.removeAttr("class").addClass("note note--" + calloutColor);

    $callout.removeAttr("class").addClass("callout callout--" + calloutColor);
  });
});

$(".image-with-lightbox").magnificPopup({
  type: "image",
  closeOnContentClick: true,
  closeBtnInside: false,
  fixedContentPos: true,
  mainClass: "mfp-with-zoom", // class to remove default margin from left and right side
  image: {
    verticalFit: true
  },
  zoom: {
    enabled: true,
    duration: 300 // don't foget to change the duration also in CSS
  }
});

$(".image-with-video-icon").magnificPopup({
  disableOn: 700,
  type: "iframe",
  mainClass: "mfp-fade",
  removalDelay: 160,
  preloader: false,
  fixedContentPos: false
});

$(".portfolio__content").each(function() {
  $(this).magnificPopup(ZDT.galleryOptions);
});

$(".case__popups a").magnificPopup({
  type: "image",
  closeOnContentClick: true,
  closeBtnInside: false,
  mainClass: "mfp-with-zoom mfp-with-scroll", // class to remove default margin from left and right side
  zoom: {
    enabled: true,
    duration: 300 // don't foget to change the duration also in CSS
  }
});

$(".comparison__theme a").magnificPopup({
  type: "image",
  closeOnContentClick: true,
  closeBtnInside: false,
  mainClass: "mfp-with-zoom mfp-with-scroll", // class to remove default margin from left and right side
  zoom: {
    enabled: true,
    duration: 300 // don't foget to change the duration also in CSS
  }
});

$(".comparison__layouts-col a").magnificPopup({
  type: "image",
  closeOnContentClick: true,
  closeBtnInside: false,
  mainClass: "mfp-with-zoom mfp-with-scroll", // class to remove default margin from left and right side
  zoom: {
    enabled: true,
    duration: 300 // don't foget to change the duration also in CSS
  }
});

$(".accordion__item-title").on("click", function() {
  var $title = $(this);
  $title.toggleClass("accordion__item-title--active");
  $title
    .parents(".accordion__item")
    .find(".accordion__item-content")
    .slideToggle();
});

$(".tabs-link").click(function(e) {
  e.preventDefault();
  var $link = $(this);
  var tabIndex = $link.index();
  var $tab = $link
    .parents(".tabs")
    .find(".tab")
    .eq(tabIndex);
  $link
    .addClass("is-active")
    .siblings()
    .removeClass("is-active");
  $tab
    .removeClass("is-hidden")
    .siblings(".tab")
    .addClass("is-hidden");
});

// Toggle content for the bad and good design page:
var buttons = $(".design-flaw-section__button");
buttons.click(function() {
  $(this).addClass("hidden-state");
});

buttons.on("transitionend", function(event) {
  if (event.originalEvent.propertyName !== "opacity") {
    return;
  }

  var button = $(event.target);
  button.addClass("hidden");
  var container = button.parent().find(".design-flaw-section__explanation");
  container.show();
  // Trigger reflow:
  container.get(0).offsetWidth;
  container.addClass("active");
  // Set the minimum height to avoid the content "jumping":
  var wrapper = container.find(".design-flaw-section__explanation-wrapper");
  wrapper.css("min-height", wrapper.outerHeight() + "px");
});

var switches = $(".design-flaw-section .toggle-switch");
switches.click(function() {
  $(this).toggleClass("active");
  var section = $(this).closest(".design-flaw-section");
  var examples = section.find(".design-flaw-section__example");
  var wrapper = section.find(".design-flaw-section__explanation-wrapper");
  var explanations = wrapper.find(".design-flaw-section__explanation-text");
  examples.toggleClass("active");
  wrapper.toggleClass("after");
  explanations.toggleClass("hidden");
});

var $nav = $("[data-nav]");
var $navLinks = $("[data-nav-pills]");
var $navigationLinks = $("[data-nav-links]");
var $sectionIdTonavigationLink = {};
var $filterBtns = $("[data-filter-btn]");
var $oneCardSlider = $("[data-background-slider]");
var $oneCardSliderBackground = $("[data-slider-backgrounds]");
var oneCardInit = false;
var animateOneCardSlider = false;
var $sectionsList = $(
  $("[data-feature-section]")
    .get()
    .reverse()
);

$(function() {
  showTopImages();

  // map each section id to their corresponding navigation link
  $sectionsList.each(function() {
    var id = $(this).attr("id");
    $sectionIdTonavigationLink[id] = $("[data-nav-links][href=\\#" + id + "]");
  });

  var scrollPos = $(document).scrollTop();
  addStyleToNav(scrollPos);
  highlightNavigation(scrollPos);

  $oneCardSlider.on("init", function() {
    oneCardInit = true;
  });

  $oneCardSlider.slick({
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    fade: true,
    cssEase: "linear",
    prevArrow:
      '<button type="button" class="slick-prev"><svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g opacity="0.8"><path d="M13.0711 15.0711L6 8L13.0711 0.928932" stroke="white" stroke-width="1.7"/></g></svg></button>',
    nextArrow:
      '<button type="button" class="slick-next"><svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g opacity="0.8"><path d="M11.9289 15.0711L19 8L11.9289 0.928932" stroke="white" stroke-width="1.7"/></g></svg></button>'
  });
  $oneCardSlider.slick("pause");

  // Listen slider events:
  $oneCardSlider.on("beforeChange", function(
    event,
    slick,
    currentSlide,
    nextSlide
  ) {
    var index = nextSlide + 1;

    $oneCardSliderBackground.find("img").removeClass("active");
    $oneCardSliderBackground
      .find("img:nth-child(" + index + ")")
      .addClass("active");
  });

  $filterBtns.click(function() {
    var $currentFilter = $(this);
    var type = $currentFilter.data("type");
    $("[data-filter-btn]").removeClass("active");
    $currentFilter.addClass("active");
    filterFeatureItems(type);
  });

  $(window).scroll(function() {
    var scrollPos = $(document).scrollTop();

    // check if scroll page up
    isScrollUp(this);

    // Add styles for fixed nav
    addStyleToNav(scrollPos);
    highlightNavigation(scrollPos);

    if (oneCardInit) {
      startAutoplay(
        $oneCardSlider,
        animateOneCardSlider,
        "animateOneCardSlider"
      );
    }
  });

  // var $casesSl = $(".cases__slider");

  // if ($casesSl.length > 0) {
  //   $casesSl.slick({
  //     centerMode: true,
  //     centerPadding: "100px",
  //     slidesToShow: 2,
  //     prevArrow: $("[data-control-prev]"),
  //     nextArrow: $("[data-control-next]"),
  //     dots: true,
  //     autoplay: true,
  //     autoplaySpeed: 1000,
  //     responsive: [
  //       {
  //         breakpoint: 768,
  //         settings: {
  //           arrows: false,
  //           centerMode: false,
  //           autoplay: false,
  //           slidesToShow: 1
  //         }
  //       }
  //     ]
  //   });
  // }
});

/**
 * Highlight navigation in sticky meny
 * @param {number} scrollPosition
 */
function highlightNavigation(scrollPosition) {
  // iterate the sections
  $sectionsList.each(function() {
    var currentSection = $(this);
    // get the position of the section
    var sectionTop = currentSection.offset().top - 100;

    // if the user has scrolled over the top of the section
    if (scrollPosition >= sectionTop) {
      // get the section id
      var id = currentSection.attr("id");
      // get the corresponding navigation link
      var $navigationLink = $sectionIdTonavigationLink[id];

      if ($navigationLink.length > 0) {
        // if the link is not active
        if (!$navigationLink.hasClass("active")) {
          // remove .active class from all the links
          $navigationLinks.removeClass("active");
          // add .active class to the current link
          $navigationLink.addClass("active");
        }
      }
      // we have found our section, so we return false to exit the each loop
      return false;
    }
  });
}

/**
 * Show top block image on after page load
 */
function showTopImages() {
  var timeout = 1000;
  $(".features-page__img-slide-up img").each(function() {
    var img = $(this);

    setTimeout(function() {
      img.addClass("shown");
    }, timeout);

    timeout += 600;
  });
}

/**
 * Fix nav on scroll
 * @param {nubmer} scrollPos
 */
function addStyleToNav(scrollPos) {
  if (scrollPos >= 145 && !$nav.hasClass("sticky")) {
    $nav.addClass("sticky");
  } else if (scrollPos < 145 && $nav.hasClass("sticky")) {
    $nav.removeClass("sticky");
  }
}

/**
 * Filter slider items on click
 * @param {string} type
 */
function filterFeatureItems(type) {
  if (type === "All") {
    $("[data-feature-item]").removeAttr("hidden");
  } else {
    $("[data-feature-item]").each(function(index, el) {
      var itemType = $(el).attr("data-type");
      $(el).removeAttr("hidden");
      if (type !== itemType) {
        $(el).attr("hidden", "hidden");
      }
    });
  }
}

/**
 * Check if scroll go up
 * @param {number} pos
 */
function isScrollUp(pos) {
  if (pos.oldScroll > pos.scrollY) {
    if (!$navLinks.hasClass("scroll-up")) {
      $navLinks.addClass("scroll-up");
    }
  } else if ($navLinks.hasClass("scroll-up")) {
    $navLinks.removeClass("scroll-up");
  }

  pos.oldScroll = pos.scrollY;
}

/**
 * Start slider autoplay if block visible
 * @param {element} slider
 * @param {boolean} dump
 * @param {string} checker
 */
function startAutoplay(slider, dump, checker) {
  if (slider.visible(true) && !window[checker]) {
    slider.slick("play");
    window[checker] = true;
  } else if (!slider.visible(true) && window[checker]) {
    slider.slick("pause");
    window[checker] = false;
  }
}

if ($('.horizontal').length) {
  var rellax = new Rellax('.horizontal', {
    horizontal: true,
  });
  
  if ($(window).width() > 1919) {
    rellax.destroy();
  };
  
  
  $(window).on('scroll resize', function() {
    if ($(window).width() > 1919) {
      rellax.destroy();
        } else {
          rellax.refresh();
        }
  });
  
}
